export default function Footer() {
    return (
        <div style={{ backgroundColor: "#255265" }}>
            <footer className="container py-4 mt-5">
                <div className='row'>
                    <div className='col-lg-9 col-xs-9 text-start' style={{color:'#e7d2b7'}}>
                        <p>© Copyright {new Date().getFullYear()} Freese & Nichols, Inc.</p>
                    </div>
                </div>
            </footer>
        </div>
    )
}